import { useContext } from "react";
import { useSelector } from "react-redux";
import { GanttFilter, OptimizedGantt, Sort } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  gantt: OptimizedGantt;
  currentPage: number;
  canRetrieveNextElements: boolean;
  retrieveOptimizedGantt(
    request: Boundaries["retrieveOptimizedGantt"]["request"],
  ): void;
}

function useRetrieveOptimizedGantt(
  filter: GanttFilter,
  sort: Sort,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveOptimizedGanttRequestPending(filter, sort, size),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveOptimizedGanttRequestSuccess(filter, sort, size),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveOptimizedGanttRequestFailure(filter, sort, size),
    ),
    currentPage: useSelector(() =>
      selector.getOptimizedGanttPage(filter, sort, size),
    ),
    gantt: useSelector(() => selector.getOptimizedGantt(filter, sort, size)),
    canRetrieveNextElements: useSelector(() =>
      selector.canRetrieveOptimizedGantt(filter, sort, size),
    ),
    retrieveOptimizedGantt: core.retrieveOptimizedGantt,
  };
}

export { useRetrieveOptimizedGantt };
